<template>
  <div>
    <ol class="breadcrumb float-xl-end">
      <li class="breadcrumb-item">Feszültségmentesítések</li>
      <li class="breadcrumb-item active">{{ isolation.name }}</li>
    </ol>
    <h1 class="page-header">Feszültségmentesítés részletei</h1>
    <NoRecords
      v-if="isolation.notfound"
      main_icon="fas fa-user-lock"
      value="false"
      title="Nem található a feszültségmentesítés"
      subtitle="Menjen vissza a feszültségmentesítések listájára!"
    >
    </NoRecords>
    <div class="row" v-if="!isolation.notfound">
      <div class="col-md-5">
        <panel title="Részletek">
          <Loading
            v-if="
              isolation === false ||
              task === false ||
              isolation_statuses === false
            "
            title="Feszültségmentesítés betöltése"
          ></Loading>
          <div v-else>
            <table class="table table-hover">
              <tbody>
                <tr>
                  <th>Név</th>
                  <td>
                    {{ isolation.position.name }} [{{
                      isolation.position.position_id
                    }}]
                  </td>
                </tr>
                <tr>
                  <th>Létrehozva</th>
                  <td>
                    {{ isolation.created_at | moment("YYYY-MM-DD HH:mm") }}
                  </td>
                </tr>
                <tr>
                  <th>Létrehozta</th>
                  <td>{{ task.owner_simple.name }}</td>
                </tr>
                <tr>
                  <th>Területvezető</th>
                  <td>{{ task.location_leader_simple.name }}</td>
                </tr>
                <tr>
                  <th>Kék lakat felvevő</th>
                  <td>
                    {{
                      task.ddc_user_simple ? task.ddc_user_simple.name : "nincs"
                    }}
                  </td>
                </tr>
                <tr>
                  <th>Operátor</th>
                  <td>{{ task.operator_simple.name }}</td>
                </tr>
                <tr>
                  <th>Villanyszerelő</th>
                  <td>{{ isolation.electrician_name }}</td>
                </tr>
                <tr>
                  <th>Elindítva</th>
                  <td>
                    <span class="badge bg-warning">{{ task.started_at }}</span>
                  </td>
                </tr>
                <tr>
                  <th>Státusz</th>
                  <td>
                    <span>{{
                      isolation_statuses.find((is) => is.id == isolation.status)
                        .name
                    }}</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </panel>
        <panel title="Munkafolyamat adatok">
          <Loading
            v-if="task === false"
            title="Munkafolyamat betöltése"
          ></Loading>
          <div v-else>
            <table class="table table-hover">
              <tbody>
                <tr>
                  <th>Mf. #</th>
                  <td>
                    <router-link
                      :to="'/tasks/' + task.id + '/edit'"
                      class="btn btn-dark btn-xs"
                      title="munkafolyamathoz"
                    >
                      {{ task.id }}
                      <i class="fa fa-paper-plane"></i>
                    </router-link>
                  </td>
                </tr>
                <tr>
                  <th>Név</th>
                  <td>{{ task.name }}</td>
                </tr>
                <tr>
                  <th>Leírás</th>
                  <td>{{ task.description ? task.description : "nincs" }}</td>
                </tr>
                <tr>
                  <th>Lakatolás</th>
                  <td>
                    <span v-if="security_types">{{
                      security_types.find((s) => s.id == task.security_type)
                        .name
                    }}</span>
                  </td>
                </tr>
                <tr>
                  <th>Létrehozva</th>
                  <td>{{ task.created_at | moment("YYYY-MM-DD HH:mm") }}</td>
                </tr>
                <tr>
                  <th>Létrehozta</th>
                  <td>{{ task.owner_simple.name }}</td>
                </tr>
                <tr>
                  <th>Területvezető</th>
                  <td>{{ task.location_leader_simple.name }}</td>
                </tr>
                <tr>
                  <th>Kék lakat felvevő</th>
                  <td>
                    {{
                      task.ddc_user_simple ? task.ddc_user_simple.name : "nincs"
                    }}
                  </td>
                </tr>
                <tr>
                  <th>Operátor</th>
                  <td>
                    <span v-if="task.operator_simple">{{
                      task.operator_simple.name
                    }}</span>
                    <span v-else> nincs operátorhoz rendelve </span>
                  </td>
                </tr>
                <tr>
                  <th>Utasítás</th>
                  <td>{{ task.workflow ? task.workflow.name : "nincs" }}</td>
                </tr>
                <tr v-if="task.workflow">
                  <th>Utasítás részletei</th>
                  <td>{{ task.workflow.description }}</td>
                </tr>
                <tr v-if="task.started_at">
                  <th>Elindítva</th>
                  <td>
                    <span class="badge bg-warning">{{ task.started_at }}</span>
                  </td>
                </tr>
                <tr>
                  <th>Státusz</th>
                  <td>
                    <Loading mini v-if="!task_statuses"></Loading>
                    <span v-else>{{
                      task_statuses.find((ts) => ts.id == task.status).name
                    }}</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </panel>

        <!--	<h3>Isolation:</h3>
					{{isolation}} 
					<h3>Isolation statuses:</h3>
					{{isolation_statuses}}
					<h3>Task:</h3>
					{{task}}
				-->
      </div>
      <div class="col-md-7">
        <panel title="Feszültségmentesítési műveletek">
          <NoRecords
            v-if="isolation.notfound"
            main_icon="fas fa-user-lock"
            value="false"
            title="Nem található a feszültségmentesítés"
            subtitle="Menjen vissza a feszültségmentesítések listájára!"
          ></NoRecords>
          <Loading
            v-else-if="
              isolation === false ||
              task === false ||
              isolation_statuses === false
            "
            title="Cellák betöltése"
          ></Loading>
          <div v-else-if="isolation.position.is_high_voltage">
            <h3 class="text-center">
              6,3kV Hajtás - {{ isolation.position.name }}
            </h3>
            <table class="table" v-if="isolation.status < 11">
              <thead>
                <tr>
                  <th>Cella</th>
                  <th>Fent</th>
                  <th>Lent</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(cell, id) in isolation.position.cells" :key="id">
                  <td>{{ cell }}</td>
                  <td>
                    <SelectLock
                      :button_disabled="isolation.user_id != user.id"
                      @lock_selected="applyRedLock($event, cell, 2)"
                      :color="3"
                      :locks="red_locks"
                      :position_id="isolation.position.id"
                      :cell_id="cell"
                      :isolation_location="2"
                      btnClass="btn-lg bg-red"
                      lockIconClass="fa fa-3x"
                      v-if="
                        isolation.red_locks == null ||
                        !isolation.red_locks.find(
                          (rl) =>
                            rl.cell_id == cell && rl.isolation_location == 2
                        )
                      "
                    >
                    </SelectLock>
                    <div class="input-group" v-else>
                      <button
                        v-show="
                          isolation.status < 5 && isolation.user_id == user.id
                        "
                        class="input-group-text bg-white"
                        @click="
                          freeRedLock(
                            isolation.red_locks.find(
                              (rl) =>
                                rl.cell_id == cell && rl.isolation_location == 2
                            )
                          )
                        "
                      >
                        <i class="fa fa-delete-left fa-2x text-red"></i>
                      </button>
                      <span class="form-control"
                        ><i class="fa fa-lock fa-2x text-red"></i> #
                        {{
                          isolation.red_locks.find(
                            (rl) =>
                              rl.cell_id == cell && rl.isolation_location == 2
                          ).lock_name
                        }}</span
                      >
                    </div>
                  </td>
                  <td>
                    <SelectLock
                      :button_disabled="isolation.user_id != user.id"
                      @lock_selected="applyRedLock($event, cell, 1)"
                      :color="3"
                      :locks="red_locks"
                      :position_id="isolation.position.id"
                      :cell_id="cell"
                      :isolation_location="1"
                      btnClass="btn-lg bg-red"
                      lockIconClass="fa fa-3x"
                      v-if="
                        isolation.red_locks == null ||
                        !isolation.red_locks.find(
                          (rl) =>
                            rl.cell_id == cell && rl.isolation_location == 1
                        )
                      "
                    >
                    </SelectLock>
                    <div class="input-group" v-else>
                      <button
                        v-show="
                          isolation.status < 5 && isolation.user_id == user.id
                        "
                        class="input-group-text bg-white"
                        @click="
                          freeRedLock(
                            isolation.red_locks.find(
                              (rl) =>
                                rl.cell_id == cell && rl.isolation_location == 1
                            )
                          )
                        "
                      >
                        <i class="fa fa-delete-left fa-2x text-red"></i>
                      </button>
                      <span class="form-control"
                        ><i class="fa fa-lock fa-2x text-red"></i> #
                        {{
                          isolation.red_locks.find(
                            (rl) =>
                              rl.cell_id == cell && rl.isolation_location == 1
                          ).lock_name
                        }}</span
                      >
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            <div v-else class="text-center mb-5">
              <hr />
              <h3>
                <i class="fa-solid fa-lock-open text-danger"></i> Lakatok
                eltávolítva
              </h3>
              <br />
              <span
                class="badge fs-18px rounded-pill"
                :class="
                  isolation_statuses.find((is) => is.id == isolation.status)
                    .bg_class
                "
              >
                {{
                  isolation_statuses.find((is) => is.id == isolation.status)
                    .name
                }}
              </span>
            </div>
            <div
              class="text-end"
              v-if="
                [task.operator_id, isolation.user_id, task.owner_id].includes(
                  user.id
                )
              "
            >
              <!--([task.owner_id].includes(user.id) && user.role_id == 5)-->
              <button
                v-if="
                  isolation.status == 6 &&
                  [task.operator_id].includes(user.id) &&
                  user.role_id == 7
                "
                :disabled="loading"
                @click="updateStatus('op_approved')"
                class="btn btn-lg btn-yellow"
              >
                <i class="fa fa-check"></i> Lakatok eltávolíthatóak, feszültség
                alá helyezés megkezdődhet
              </button>
              <button
                v-else-if="
                  isolation.status == 6 && ![task.operator_id].includes(user.id)
                "
                disabled
                class="btn btn-lg btn-secondary"
              >
                <i class="fa fa-clock"></i> Várakozás Operátori jóváhagyásra
              </button>
              <!-- INFO Itt korábban a locks_removed állapotba ment, de ezt később Bence kivette, csak nem módosította a viewkat ennek megfelelően, ezért rossz lett a napló. Javítva azzal, hogy automatikusan beléptetjük a locks_removedba és onnan a reconnected-be-->
              <button
                v-else-if="
                  isolation.status == 7 && user.id == isolation.user_id
                "
                :disabled="loading"
                @click="updateStatus('reconnected')"
                class="btn btn-lg btn-green"
              >
                <i class="fa fa-lock"></i> Lakatok eltávolítva, feszültség alá
                helyezve
              </button>
              <button
                v-else-if="
                  isolation.status == 9 &&
                  user.id == task.operator_id &&
                  user.role_id == 7
                "
                :disabled="loading"
                @click="updateStatus('operator_accepted')"
                class="btn btn-lg btn-yellow text-black"
              >
                <i class="fa fa-bolt"></i> Feszültség alá helyezés
              </button>
              <button
                v-else-if="
                  isolation.status == 10 && user.id == isolation.user_id
                "
                :disabled="loading"
                @click="updateStatus('reconnected')"
                class="btn btn-lg btn-danger"
              >
                <i class="fa fa-bolt"></i> Feszültség alá helyezve
              </button>
              <button
                v-else-if="
                  isolation.status == 11 &&
                  user.id == task.operator_id &&
                  user.role_id == 7
                "
                :disabled="loading"
                @click="updateStatus('operator_acknowledged')"
                class="btn btn-lg btn-lime text-dark"
              >
                <i class="fa fa-check-circle"></i> Feszültség alá helyezés
                befejezése
              </button>
              <button
                v-else-if="isolation.status == 12"
                class="btn btn-success"
                disabled
              >
                <i class="fa fa-check-circle"></i> Befejezve
              </button>
              <button
                v-else-if="[1, 8, 9, 11, 6].includes(isolation.status)"
                class="btn btn-info"
                disabled
              >
                <i class="fa fa-clock"></i> Várakozás operátorra
              </button>
              <button
                v-else-if="[2, 3, 4, 5, 7, 10].includes(isolation.status)"
                class="btn btn-info"
                disabled
              >
                <i class="fa fa-clock"></i> Várakozás villanyszerelőre
              </button>
              <button
                v-else-if="[6].includes(isolation.status)"
                class="btn btn-info"
                disabled
              >
                <i class="fa fa-clock"></i> Várakozás projektvezetőre
              </button>
              <button
                disabled
                class="btn"
                :class="
                  isolation_statuses.find((is) => is.id == isolation.status)
                    .bg_class
                "
                v-else
              >
                <span class="text-white">{{
                  isolation_statuses.find((is) => is.id == isolation.status)
                    .name
                }}</span>
              </button>
              <button
                v-if="
                  back_url &&
                  [4, 5, 6].includes(isolation.status) &&
                  user.id == isolation.user_id
                "
                @click="ticketPrinted"
                class="btn btn-success btn-lg ms-3"
              >
                <i class="fa fa-print"></i> Munkajegy nyomtatása
              </button>
            </div>
          </div>
          <div v-else class="text-center">
            <h3 class="text-center">
              0,4kV Hajtás - {{ isolation.position.name }}
            </h3>
            <button
              class="btn btn-block btn-indigo my-4"
              v-if="isolation.status == 3 && user.id == isolation.user_id"
              :disabled="loading"
              @click="updateStatus('isolated')"
            >
              <i class="fa fa-2x fa-spin fa-cog" v-if="loading"></i>
              <span class="fa-stack fa-2x" v-else>
                <i class="fa fa-bolt fa-stack-1x"></i>
                <i class="fa fa-ban fa-stack-2x"></i>
              </span>
              <span class="fs-20px">Feszültségmentesítés</span>
            </button>
            <button
              class="btn btn-block btn-yellow text-black my-4 p-3"
              v-else-if="
                isolation.status == 6 &&
                user.id == task.operator_id &&
                user.role_id == 7
              "
              :disabled="
                loading || isolation.active_temporary_reconnect != null
              "
              @click="updateStatus('operator_accepted')"
            >
              <i class="fa fa-bolt fa-2x"></i>
              <span class="fs-20px"> Feszültség alá helyezés</span>
            </button>
            <button
              class="btn btn-block btn-danger my-4 p-3"
              v-else-if="isolation.status == 10 && user.id == isolation.user_id"
              :disabled="loading"
              @click="updateStatus('reconnected')"
            >
              <i class="fa fa-bolt fa-2x"></i>
              <span class="fs-20px"> Feszültség alá helyezve</span>
            </button>
            <button
              class="btn btn-block btn-lime text-black my-4 p-3"
              v-else-if="
                isolation.status == 11 &&
                user.id == task.operator_id &&
                user.role_id == 7
              "
              :disabled="loading"
              @click="updateStatus('operator_acknowledged')"
            >
              <i class="fa fa-check-circle fa-2x"></i>
              <span class="fs-20px"> Feszültség alá helyezés befejezése</span>
            </button>
            <button
              class="btn btn-block btn-success my-4 p-3"
              v-else-if="isolation.status == 12"
              disabled
            >
              <i class="fa fa-check-circle fa-2x"></i>
              <span class="fs-20px"> Befejezve</span>
            </button>
            <button
              class="btn btn-block btn-pink my-4 p-3"
              v-else-if="[6].includes(isolation.status)"
              disabled
            >
              <i class="fa fa-clock fa-2x"></i>
              <span class="fs-20px"> Feszültségmentesítve</span>
            </button>
            <button
              class="btn btn-block btn-pink my-4 p-3"
              v-else-if="[1, 11].includes(isolation.status)"
              disabled
            >
              <i class="fa fa-clock fa-2x"></i>
              <span class="fs-20px"> Várakozás operátorra</span>
            </button>
            <button
              class="btn btn-block btn-pink my-4 p-3"
              v-else-if="[2, 3, 10].includes(isolation.status)"
              disabled
            >
              <i class="fa fa-clock fa-2x"></i>
              <span class="fs-20px"> Várakozás villanyszerelőre</span>
            </button>
            <button
              disabled
              class="btn btn-block my-4 p-3"
              :class="
                isolation_statuses.find((is) => is.id == isolation.status)
                  .bg_class
              "
              v-else
            >
              <span class="text-white">{{
                isolation_statuses.find((is) => is.id == isolation.status).name
              }}</span>
            </button>
            <div
              v-if="
                (user.role_id == 5 || user.id == isolation.user_id) &&
                isolation.status == 6
              "
            >
              <hr />
              <button
                v-if="
                  isolation.active_temporary_reconnect == null &&
                  user.role_id == 5
                "
                class="btn btn-danger btn-lg"
                @click="temporaryReconnectStart"
                :disabled="loading"
              >
                <i class="fa fa-stopwatch"></i> Ideiglenes fesz alá helyezés
              </button>
              <button
                v-else-if="
                  isolation.active_temporary_reconnect != null &&
                  isolation.active_temporary_reconnect.reconnected_at == null &&
                  user.id == isolation.user_id
                "
                class="btn btn-yellow btn-lg"
                @click="temporaryReconnectReconnect"
                :disabled="loading"
              >
                <i class="fa fa-stopwatch"></i> Ideiglenesen fesz alá helyezve
              </button>
              <button
                v-else-if="
                  isolation.active_temporary_reconnect != null &&
                  isolation.active_temporary_reconnect.closed_at == null &&
                  isolation.active_temporary_reconnect.reconnected_at != null &&
                  user.role_id == 5
                "
                class="btn btn-danger btn-lg"
                @click="temporaryReconnectClose"
                :disabled="loading"
              >
                <i class="fa fa-stopwatch"></i> Újra feszmentesítés
              </button>
              <button
                v-else-if="
                  isolation.active_temporary_reconnect != null &&
                  isolation.active_temporary_reconnect.isolated_at == null &&
                  isolation.active_temporary_reconnect.closed_at != null &&
                  user.id == isolation.user_id
                "
                class="btn btn-yellow btn-lg"
                @click="temporaryReconnectIsolate"
                :disabled="loading"
              >
                <i class="fa fa-stopwatch"></i> Újra feszmentesítve
              </button>
              <button
                v-else-if="user.role_id == 5"
                disabled
                class="btn btn-danger"
              >
                <i class="fa fa-stopwatch"></i> Villanyszerelőre vár
              </button>
              <button
                v-else-if="isolation.active_temporary_reconnect != null"
                disabled
                class="btn btn-yellow"
              >
                <i class="fa fa-stopwatch"></i> Projektvezetőre vár
              </button>
            </div>
          </div>
        </panel>
      </div>
    </div>
  </div>
</template>

<script>
import Task from "../../apis/Task";
import Lock from "../../apis/Lock";
import Isolation from "../../apis/Isolation";
import User from "../../apis/User";
import Partner from "../../apis/Partner";
import Loading from "../../components/Loading";
import SelectLock from "../../components/SelectLock";
export default {
  components: {
    Loading,
    SelectLock,
  },
  data() {
    return {
      task: false,
      users: false,
      errors: [],
      isolation_statuses: false,
      task_statuses: false,
      loading: false,
      free_locks: false,
      isolation: false,
      locks: false,
      back_url: false,
      partner_users: false,
      partner: false,
      security_types: false,
    };
  },
  mounted() {
    this.back_url = process.env.VUE_APP_BACK_URL;
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    red_locks() {
      if (this.free_locks) {
        return this.free_locks.filter((l) => l.color == 3);
      }
      return [];
    },
  },
  watch: {
    $route() {
      this.refalser();
      this.initializer();
    },
  },
  created() {
    this.refalser();
    this.initializer();
  },
  methods: {
    temporaryReconnectReconnect() {
      this.loading = true;
      Isolation.temporaryReconnectReconnect({
        isolation_id: this.isolation.id,
      }).finally(() => {
        this.loading = false;
      });
    },
    temporaryReconnectIsolate() {
      this.loading = true;
      Isolation.temporaryReconnectIsolate({
        isolation_id: this.isolation.id,
      }).finally(() => {
        this.loading = false;
      });
    },
    temporaryReconnectStart() {
      this.loading = true;
      Isolation.temporaryReconnectStart({
        isolation_id: this.isolation.id,
      }).finally(() => {
        this.loading = false;
      });
    },
    temporaryReconnectClose() {
      this.loading = true;
      Isolation.temporaryReconnectClose({
        isolation_id: this.isolation.id,
      })
        .catch((error) => {
          // Handle error here
          if (error.response && error.response.status === 403) {
            // Handle 403 Forbidden error
            console.error("403 Forbidden Error:", error.response.data);
            // Perform actions specific to 403 error, such as showing an error message
          } else {
            // Handle other errors
            console.error("Error occurred:", error);
            // Perform general error handling actions
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    refalser() {
      window.Echo.private("App.Isolation." + this.isolation.id).unsubscribe();
      this.task = false;
      this.users = false;
      this.errors = [];
      this.isolation_statuses = false;
      this.task_statuses = false;
      this.loading = false;
      this.free_locks = false;
      this.isolation = false;
      this.locks = false;
      this.back_url = false;
      this.partner_users = false;
      this.partner = false;
      this.security_types = false;
    },
    initializer() {
      window.Echo.private("App.Isolation." + this.$route.params.id).listen(
        "RedLocksUpdated",
        (e) => {
          this.$set(this.isolation, "red_locks", e);
        }
      );

      window.Echo.channel("locks")
        .listen("SetLock", (e) => {
          this.free_locks.splice(
            this.free_locks.map((fl) => fl.id).indexOf(e.id),
            1
          );
        })
        .listen("LockRelease", (e) => {
          this.free_locks.push(e);
          this.free_locks = this.free_locks.sort((a, b) => a.id > b.id);
        });

      window.Echo.channel("isolations").listen("IsolationUpdated", (e) => {
        if (e.id == this.isolation.id) {
          this.isolation.status = e.status;
          this.isolation.active_temporary_reconnect =
            e.active_temporary_reconnect;
        }
      });

      Lock.free().then((response) => {
        this.free_locks = response.data;
      });

      Isolation.show(this.$route.params.id)
        .then((response) => {
          this.$set(this, "isolation", response.data);
          Task.show(this.isolation.first_task_id)
            .then((response) => {
              window.Echo.private(
                "App.Task." + this.isolation.first_task_id
              ).listen("TaskEditUpdated", (e) => {
                Task.show(e.id)
                  .then((response) => {
                    this.$set(this, "task", response.data);
                  })
                  .catch(() => {
                    this.$set(this, "task", {
                      name: "ismeretlen",
                      notfound: true,
                    });
                  });
              });
              this.$set(this, "task", response.data);
              if (response.data.partner_id) {
                User.getRole(6).then((response) => {
                  if (response.data.length != 0) {
                    this.partner_users = response.data.filter(
                      (item) => item.partner_id == this.task.partner_id
                    );
                  } else {
                    this.partner_users = response.data;
                  }
                });
                Partner.show(response.data.partner_id).then((response) => {
                  this.partner = response.data;
                });
              }
              /*if(this.user.role_id == 7){
								Task.setOperator(this.task.id,{operator_id: this.user.id});
							}*/
              //console.log([...new Set(this.task.task_permits.map(item => item.permit_type))])
            })
            .catch(() => {
              this.$set(this, "task", { name: "ismeretlen", notfound: true });
            });
        })
        .catch(() => {
          this.$set(this, "isolation", { name: "ismeretlen", notfound: true });
        });

      this.isolation_statuses = JSON.parse(
        localStorage.getItem("constants")
      ).isolation_status;
      this.task_statuses = JSON.parse(
        localStorage.getItem("constants")
      ).task_status;
      this.security_types = JSON.parse(
        localStorage.getItem("constants")
      ).security_types;
    },
    updateStatus(status) {
      this.$set(this, "loading", true);
      Isolation.statusUpdate(this.isolation.id, { status: status })
        .then(() => {
          history.back();
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.$set(this, "loading", false);
        });
    },
    ticketPrinted() {
      if (this.isolation.status < 5) {
        Isolation.statusUpdate(this.isolation.id, {
          status: "ticket_printed",
        }).then(() => {
          window.open(
            this.back_url + "/document/pdf/ticket/" + this.isolation.id,
            "_blank"
          );
        });
      } else {
        window.open(
          this.back_url + "/document/pdf/ticket/" + this.isolation.id,
          "_blank"
        );
      }
    },
    applyRedLock(event, cell, isolation_location) {
      Isolation.ApplyRedLock(this.isolation.id, {
        position_id: event.position_id,
        cell_id: parseInt(cell),
        isolation_location: isolation_location,
        lock_id: event.lock_id,
      }).then((response) => {
        this.$set(this.isolation, "red_locks", response.data);
      });
    },
    freeRedLock(lock) {
      Isolation.FreeRedLock(this.isolation.id, lock).then((response) => {
        this.$set(this.isolation, "red_locks", response.data);
      });
    },
    freeLock(position, color) {
      let vue = this;
      new Promise((resolve) => {
        let user_id = null;
        switch (color) {
          case 1:
            user_id = vue.task.ddc_user_id;
            break;
          case 4:
            user_id = vue.task.partner_user_id;
            break;
        }
        resolve({ user_id: user_id });
      }).then((response) => {
        Task.freePositionLock(this.task.id, {
          task_position_id: position.id,
          user_id: response.user_id,
          lock_id: position.locks.find((l) => l.color == color).id,
        }).then(() => {
          //this.$set(this.free_locks.find(fl => fl.id == position.lock_id),'position_id',null)
          position.locks.splice(
            position.locks.map((l) => l.color).indexOf(color),
            1
          );
          this.$forceUpdate(position);
        });
      });
    },
    deselectLock(box, key) {
      console.log(box, key);
    },
    boxLockSelected(box, event, key) {
      this.$set(box, key, event.lock_id);
    },
    saveTaskBoxes() {
      Task.setLocks(this.task.id, { boxes: this.boxes_to_send });
    },
    checkPosition(position, btn_number) {
      if (btn_number == 1 && position.unplug == 0) {
        this.$set(position, "locking", 1);
      } else if (btn_number == 2 && position.locking == 1) {
        this.$set(position, "unplug", 0);
      }
    },
    closeModal(modal_name) {
      this.$bvModal.hide(modal_name);
    },

    setUnplugUserId(id, unplug_u_id) {
      this.task_positions[
        this.task_positions.map((tp) => tp.id).indexOf(id)
      ].unplug_user_id = unplug_u_id;
    },
    SetLockIdToNull(id) {
      this.$delete(
        this.free_locks.find(
          (f) =>
            f.position_id ==
            this.task_positions.find((tp) => tp.id == id).position_id
        ),
        "position_id"
      );
      this.task_positions[
        this.task_positions.map((tp) => tp.id).indexOf(id)
      ].lock_id = null;
    },
    setLockId(id, l_id) {
      this.$set(
        this.task_positions[this.task_positions.map((tp) => tp.id).indexOf(id)],
        "lock_id",
        l_id
      );
      this.$forceUpdate(
        this.task_positions[this.task_positions.map((tp) => tp.id).indexOf(id)]
      );
    },
    lockSelected(obj, color) {
      let vue = this;
      new Promise((resolve) => {
        let user_id = null;
        switch (color) {
          case 1:
            user_id = vue.task.ddc_user_id;
            break;
          case 4:
            user_id = vue.task.partner_user_id;
            break;
        }
        resolve({ user_id: user_id });
      }).then((response) => {
        Task.setPositionLock(this.task.id, {
          task_position_id: obj.position_id,
          user_id: response.user_id,
          lock_id: obj.lock_id,
        }).then(() => {
          this.$set(
            this.free_locks.find((f) => f.id == obj.lock_id),
            "position_id",
            obj.position_id
          );
          this.task_positions
            .find((tp) => tp.id == obj.position_id)
            .locks.push({ color: color, id: obj.lock_id });
        });
      });
    },
  },
};
</script>

<style></style>
